module.exports = __webpack_public_path__ + "img/011.1f96443f.png";